module.exports = __webpack_public_path__ + "media/images/ico-sound@2x-0d5efc74323ec739606dcf4f47737bfe.png";